import { render, staticRenderFns } from "./OwnPicture.vue?vue&type=template&id=25c7b8e1&scoped=true"
import script from "./OwnPicture.vue?vue&type=script&lang=js"
export * from "./OwnPicture.vue?vue&type=script&lang=js"
import style0 from "./OwnPicture.vue?vue&type=style&index=0&id=25c7b8e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7b8e1",
  null
  
)

export default component.exports